import type { LocaleCopy } from '../types';
import { homeEs } from './home';
import { chromeEs } from './chrome';
import { aboutEs } from './about';
import { allergensEs } from './allergens';

export const es: LocaleCopy = {
  home: homeEs,
  chrome: chromeEs,
  about: aboutEs,
  allergens: allergensEs,
};
